import * as React from 'react';

export const TYPE_ORDER = 1;
export const TYPE_DISTANCE = 2;
export const TYPE_RACE = 3;

export const AMOUNT_TYPE_ORDER = 1;
export const AMOUNT_TYPE_FIXED = 3;
export const AMOUNT_TYPE_PERCENTAGE = 2;
